import { render, staticRenderFns } from "./IntegralConfigModal.vue?vue&type=template&id=376ae241&"
import script from "./IntegralConfigModal.vue?vue&type=script&lang=js&"
export * from "./IntegralConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports